import React, { useState } from 'react';
import clsx from 'clsx';
import styles from './DiceSelector.module.scss';
import Dice1 from '@static/images/dice_1.svg';
import Dice2 from '@static/images/dice_2.svg';
import Dice3 from '@static/images/dice_3.svg';
import Dice4 from '@static/images/dice_4.svg';
import Dice5 from '@static/images/dice_5.svg';
import Dice6 from '@static/images/dice_6.svg';
import DiceRed1 from '@static/images/dice_red_1.svg';
import DiceRed2 from '@static/images/dice_red_2.svg';
import DiceRed3 from '@static/images/dice_red_3.svg';
import DiceRed4 from '@static/images/dice_red_4.svg';
import DiceRed5 from '@static/images/dice_red_5.svg';
import DiceRed6 from '@static/images/dice_red_6.svg';
function getDiceImage(value, color) {
    const diceImages = color === 'red' ? {
        1: DiceRed1,
        2: DiceRed2,
        3: DiceRed3,
        4: DiceRed4,
        5: DiceRed5,
        6: DiceRed6
    } : {
        1: Dice1,
        2: Dice2,
        3: Dice3,
        4: Dice4,
        5: Dice5,
        6: Dice6
    };
    return diceImages[value];
}
const diceValues = [
    1,
    2,
    3,
    4,
    5,
    6
];
export const DiceSelector = ({ color, onSelectDice, className, disableHover })=>{
    const [selectedDice, setSelectedDice] = useState();
    const handleDiceToggle = (diceValue)=>{
        setSelectedDice(diceValue);
        onSelectDice(diceValue);
    };
    return /*#__PURE__*/ React.createElement("div", {
        className: clsx(styles.diceSelectorContainer, className)
    }, diceValues.map((value)=>{
        const image = getDiceImage(value, color);
        if (image == undefined) return null;
        return /*#__PURE__*/ React.createElement("div", {
            className: clsx(styles.diceSelector, {
                [styles.selected]: selectedDice === value,
                [styles.disableHover]: disableHover
            }),
            key: value,
            onClick: ()=>handleDiceToggle(value)
        }, /*#__PURE__*/ React.createElement("img", {
            className: styles.diceImage,
            draggable: false,
            src: image
        }));
    }));
};
